import Swiper from "./swiper-bundle.esm.browser.min.js";

if (!customElements.get("jkl-collection-filters")) {
  customElements.define(
    "jkl-collection-filters",
    class JklCollectionFilters extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.hasInteracted = false;
        this.hideTimeout = null;
      }

      connectedCallback() {
        this.swiperEl = this.querySelector('[data-filters-swiper]');
        this.prevBtn = this.querySelector('[data-filters-prev]');
        this.nextBtn = this.querySelector('[data-filters-next]');

        if (this.swiperEl) {
          this.initSwiper();
        }
      }

      disconnectedCallback() {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }
      }

      initSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true,
          watchOverflow: true,
          init: false,
        });

        // Event handlers
        this.swiper.on('afterInit', () => {
          // On mobile, show arrows immediately (no interaction required)
          if (window.innerWidth < 768) {
            this.hasInteracted = true;
          }
          this.updateNavVisibility();
        });

        this.swiper.on('sliderMove', () => {
          if (!this.hasInteracted) {
            this.hasInteracted = true;
            this.showArrows();
          }
          this.resetHideTimeout();
        });

        this.swiper.on('touchStart', () => {
          if (!this.hasInteracted) {
            this.hasInteracted = true;
            this.showArrows();
          }
          this.resetHideTimeout();
        });

        this.swiper.on('slideChange', () => {
          this.updateNavVisibility();
        });

        this.swiper.on('reachBeginning', () => {
          if (this.prevBtn) {
            this.prevBtn.classList.add('jkl-collection-filters__nav--hidden');
          }
        });

        this.swiper.on('reachEnd', () => {
          if (this.nextBtn) {
            this.nextBtn.classList.add('jkl-collection-filters__nav--hidden');
          }
        });

        this.swiper.on('fromEdge', () => {
          if (this.hasInteracted) {
            this.showArrows();
          }
        });

        // Initialize swiper
        this.swiper.init();

        // Navigation button handlers
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            if (!this.hasInteracted) this.hasInteracted = true;
            this.swiper.slidePrev();
            this.showArrows();
            this.resetHideTimeout();
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            if (!this.hasInteracted) this.hasInteracted = true;
            this.swiper.slideNext();
            this.showArrows();
            this.resetHideTimeout();
          });
        }

        // Mouse enter/leave for desktop
        this.addEventListener('mouseenter', () => {
          if (this.swiper && this.swiper.virtualSize > this.swiper.size) {
            this.hasInteracted = true;
            this.showArrows();
          }
        });

        this.addEventListener('mouseleave', () => {
          this.hideTimeout = setTimeout(() => {
            if (this.prevBtn) {
              this.prevBtn.classList.add('jkl-collection-filters__nav--hidden');
            }
            if (this.nextBtn) {
              this.nextBtn.classList.add('jkl-collection-filters__nav--hidden');
            }
          }, 1000);
        });
      }

      showArrows() {
        if (!this.swiper) return;

        const isOverflowing = this.swiper.virtualSize > this.swiper.size;

        if (!isOverflowing) {
          if (this.prevBtn) this.prevBtn.classList.add('jkl-collection-filters__nav--hidden');
          if (this.nextBtn) this.nextBtn.classList.add('jkl-collection-filters__nav--hidden');
          return;
        }

        if (this.prevBtn) {
          if (this.swiper.isBeginning) {
            this.prevBtn.classList.add('jkl-collection-filters__nav--hidden');
          } else {
            this.prevBtn.classList.remove('jkl-collection-filters__nav--hidden');
          }
        }

        if (this.nextBtn) {
          if (this.swiper.isEnd) {
            this.nextBtn.classList.add('jkl-collection-filters__nav--hidden');
          } else {
            this.nextBtn.classList.remove('jkl-collection-filters__nav--hidden');
          }
        }
      }

      updateNavVisibility() {
        if (!this.hasInteracted) return;
        this.showArrows();
      }

      resetHideTimeout() {
        if (this.hideTimeout) {
          clearTimeout(this.hideTimeout);
        }
        // On mobile, don't auto-hide arrows after timeout
        if (window.innerWidth >= 768) {
          this.hideTimeout = setTimeout(() => {
            if (this.prevBtn) this.prevBtn.classList.add('jkl-collection-filters__nav--hidden');
            if (this.nextBtn) this.nextBtn.classList.add('jkl-collection-filters__nav--hidden');
          }, 3000);
        }
      }
    }
  );
}
